module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "root"
  }, [_c('div', {
    staticClass: "header"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.msg))])]), _vm._v(" "), _c('code-editor')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-68dbbec4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 287
// module chunks = 1